import { usePage } from "@/lib/content";
import { Reveal } from "@/components/site/Motion";
import { PageHero, usePageTitle } from "@/components/site/Bits";

export default function Privacidade() {
  usePageTitle("Política de Privacidade");
  const { sections: s } = usePage("privacidade");
  const items = Array.isArray(s.items) ? s.items : [];

  return (
    <>
      <PageHero title={s.hero_title || "Política de Privacidade"} text={s.hero_text} overline="LGPD — Lei nº 13.709/2018" />
      <section className="bg-ivory">
        <div className="mx-auto max-w-3xl px-5 py-20 md:px-8 md:py-28">
          <Reveal>
            <p className="text-base leading-relaxed text-inkgray md:text-lg">{s.intro_text}</p>
          </Reveal>
          <div className="mt-12 space-y-10">
            {items.map((item, i) => (
              <Reveal key={i} delay={0.05 * i}>
                <div data-testid={`privacidade-item-${i}`}>
                  <div className="flex items-baseline gap-4">
                    <span className="font-display text-sm italic text-gold">0{i + 1}</span>
                    <h2 className="font-display text-xl text-navy md:text-2xl">{item.title}</h2>
                  </div>
                  <div className="gold-rule my-4 w-12" aria-hidden="true" />
                  <p className="text-sm leading-relaxed text-inkgray md:text-[15px]">{item.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
